export const blockTemplate = {
  'background': {
    'color': {
      'xl': '#edecf6'
    },
    'backgroundColor': {
      'xl': '#FBFBFB'
    }
  },
  'text': {
    'align': {
      'xl': 'left'
    }
  },
  'box': {
    'padding': {
      'paddingTop': {
        'xl': 100,
        'xs': 35
      },
      'paddingLeft': {
        'xl': 20,
        'xs': 5
      },
      'paddingRight': {
        'xl': 20,
        'xs': 5
      },
      'paddingBottom': {
        'xl': 100,
        'xs': 35
      }
    }
  }
};
export const blockContentTemplate = {
  'box': {
    'size': {
      'maxWidth': {
        'xl': '1445'
      }
    },
    'padding': {
      'paddingTop': {
        'xs': 10
      },
      'paddingBottom': {
        'xs': 10
      },
      'paddingLeft': {
        'xs': 12
      },
      'paddingRight': {
        'xs': 12
      }
    }
  },
};
